import { render, staticRenderFns } from "./ChangeUsernamePass.vue?vue&type=template&id=35a6cdf3&scoped=true"
import script from "./ChangeUsernamePass.vue?vue&type=script&lang=js"
export * from "./ChangeUsernamePass.vue?vue&type=script&lang=js"
import style0 from "./ChangeUsernamePass.vue?vue&type=style&index=0&id=35a6cdf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6cdf3",
  null
  
)

export default component.exports